import React from 'react';
import { SEARCH_PROVIDERS } from '@lib/constants';

type GoogleMapsLinkProps = {
  id: string;
  search_provider: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
  mapUrl?: string;
  address?: string;
};

const GoogleMapsLink = ({
  id,
  search_provider,
  coordinates,
  mapUrl,
  address
}: GoogleMapsLinkProps) => {
  const { latitude, longitude } = coordinates ?? {};

  let googleMapsUrl =
    longitude && latitude
      ? `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
      : mapUrl;
  if (search_provider === SEARCH_PROVIDERS.YELP) {
    googleMapsUrl = `https://www.yelp.com/map/${id}`;
  }

  return (
    <a
      className="text-inherit pr-1"
      href={googleMapsUrl}
      target="_blank"
      rel="noopener noreferrer "
    >
      {address}
    </a>
  );
};

export default GoogleMapsLink;
